<div class="">
  <div *ngIf="interactions" class="interactions-overview">
    <p-table [value]="interactions"
             [paginator]="true"
             [loading]="!interactions"
             paginatorPosition="bottom"
             [totalRecords]="interactions.length"
             [rows]="pageSize" class="review_table">

      <ng-template pTemplate="emptymessage" let-columns>
        <div>{{ 'WS_DIRECTORY.TABLE_EMPTY' | translate }}</div>
      </ng-template>

      <ng-template pTemplate="header">
        <tr>
          <th>{{ 'WS_DIRECTORY.ORG_MODIFY.INTERACTIONS.TABLE_INTERACTIONS.DATE_TITLE' | translate }}</th>
          <th>{{ 'WS_DIRECTORY.ORG_MODIFY.INTERACTIONS.TABLE_INTERACTIONS.PERSON_TITLE' | translate
            }}
          </th>
          <th>{{ 'WS_DIRECTORY.ORG_MODIFY.INTERACTIONS.TABLE_INTERACTIONS.ENTERED_BY_TITLE' |
            translate }}
          </th>
          <th>{{ 'WS_DIRECTORY.ORG_MODIFY.INTERACTIONS.TABLE_INTERACTIONS.SUBJECT_TITLE' |
            translate }}
          </th>
          <th style="width: 100px">{{ 'WS_DIRECTORY.ORG_MODIFY.INTERACTIONS.TABLE_INTERACTIONS.FLAGS_TITLE' |
            translate }}
          </th>
          <th style="width: 20px">
          </th>
        </tr>
      </ng-template>
      <ng-template pTemplate="body" let-entry>
        <tr>
          <td>
            {{entry.date | date: 'dd/MM/yyyy'}}
          </td>
          <td>
            {{entry.person}}
          </td>
          <td class="">
            <div *ngIf="entry.enteredBy">
              {{entry.enteredBy.firstName + ' ' + entry.enteredBy.lastName}}
            </div>
          </td>
          <td class="">
            {{entry.subject}}
          </td>
          <td class="flags">
            <span *ngIf="entry.important">
              <i class="fa fa-exclamation"
                 tooltipPosition="bottom"
                 pTooltip="{{ 'WS_DIRECTORY.ORG_MODIFY.INTERACTIONS.TABLE_INTERACTIONS.IMPORTANT_TOOLTIP' | translate }}"></i>
            </span>
            <span *ngIf="entry.confidential">
              <i class="fa fa-eye-slash"
                 tooltipPosition="bottom"
                 pTooltip="{{ 'WS_DIRECTORY.ORG_MODIFY.INTERACTIONS.TABLE_INTERACTIONS.CONFIDENTIAL_TOOLTIP' | translate }}"></i>
            </span>
          </td>
          <td class="text-right flags p-r-0">
            <span *gsShowIfHasPermission="['ORGANIZATION_INTERACTIONS_UPDATE']">
              <i class="fa fa-edit"
                 pTooltip="{{ 'WS_DIRECTORY.ORG_MODIFY.INTERACTIONS.TABLE_INTERACTIONS.TOOLTIP' | translate }}"
                 tooltipPosition="bottom"
                 (click)="modify(entry)"></i>
            </span>
          </td>
        </tr>
      </ng-template>
    </p-table>
  </div>

  <div>
    <button pButton
            *gsShowIfHasPermission="['ORGANIZATION_INTERACTIONS_UPDATE']"
            label="{{ 'WS_DIRECTORY.ORG_MODIFY.INTERACTIONS.CREATE_BUTTON' | translate}}"
            (click)="add()"
            class="m-b-30">
    </button>
  </div>
</div>

<wsd-add-organization-interaction (onSave)="onSave($event)" (onDelete)="delete($event)">
</wsd-add-organization-interaction>
